// extracted by mini-css-extract-plugin
export default {"periodSwitch":"PeriodSwitch_periodSwitch__iaAZx","periodTabs":"PeriodSwitch_periodTabs__gS9W1","nav":"PeriodSwitch_nav__O0nV1","label":"PeriodSwitch_label__qOAIu"};